import React from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import Header, { HeaderLeft, HeaderRight } from 'layout/Header/Header';
import Button from 'components/bootstrap/Button';
import useDarkMode from 'hooks/useDarkMode';
import CommonHeaderRight from './CommonHeaderRight';
import Avatar from 'components/Avatar';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'stores/store';
import { capitalizeFirstLetter } from 'helpers/helpers';
import { authMenu, profileMenu } from 'menu';
import { logout } from 'stores/authSlice';
import Dropdown, {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from 'components/bootstrap/Dropdown';
import { links } from 'helpers/urls';

const DashboardHeader = () => {
	const { darkModeStatus } = useDarkMode();

	const { user } = useSelector((state: RootState) => state.auth);

	const dispatch = useDispatch<AppDispatch>();

	const navigate = useNavigate();
	return (
		<Header>
			<HeaderLeft>
				<div className='d-flex align-items-center' data-tour='active-organization-tour'>
					<div className='row g-4'>
						<div className='col-md-auto'>
							<div
								className={classNames('fs-4', 'text-uppercase', {
									'text-dark': !darkModeStatus,
								})}>
								WHITECRUST FINANCE
							</div>
							<div className='fs-6'>Agent Dashboard</div>
						</div>
					</div>
				</div>
			</HeaderLeft>
			<HeaderRight>
				<CommonHeaderRight
					afterChildren={
						<div className='col d-flex align-items-center' data-tour='profile-tour'>
							{user && (
								<Dropdown className='d-inline-block'>
									<DropdownToggle hasIcon={false}>
										<div className='col d-flex align-items-center'>
											<div className='me-3'>
												<Avatar
													srcSet={`${links.galleryUrl}/${user?.passport_photo}`}
													src={`${links.galleryUrl}/${user?.passport_photo}`}
													size={48}
													color='primary'
												/>
											</div>
											<div>
												<div className='fw-bold fs-6 mb-0'>
													{capitalizeFirstLetter(
														`${user?.firstname ?? ''} ${user?.othername ?? ''} ${user?.lastname ?? ''}`,
													)}
												</div>
												<div className='text-muted'>
													<small>Agent</small>
												</div>
											</div>
										</div>
									</DropdownToggle>
									<DropdownMenu isAlignmentEnd>
										<DropdownItem>
											<Button
												icon={profileMenu.profile.icon}
												tag='a'
												onClick={() => navigate(profileMenu.profile.path)}>
												Profile
											</Button>
										</DropdownItem>
										<DropdownItem>
											<Button
												icon='PowerSettingsNew'
												tag='a'
												onClick={() => {
													dispatch(logout());
													navigate(authMenu.login.path, {
														replace: true,
													});
												}}>
												Logout
											</Button>
										</DropdownItem>
									</DropdownMenu>
								</Dropdown>
							)}
						</div>
					}
				/>
			</HeaderRight>
		</Header>
	);
};

export default DashboardHeader;
